"use strict";

exports.__esModule = true;
exports["default"] = exports.MAX_LIGHTNESS = void 0;
var MAX_LIGHTNESS = exports.MAX_LIGHTNESS = 90;
function getActivitiesColoring(activities, stateDetails, activityDefinitions) {
  if (activityDefinitions === void 0) {
    activityDefinitions = [];
  }
  if (!activities) return [];
  var coloredActivities = stateDetails.flatMap(function (state) {
    var initialValue = [];
    var stateActivities = activities.filter(function (activity) {
      return activity.state === state.key;
    }).reduce(function (p, c) {
      return p.includes(c.activity) ? p : p.concat([c.activity]);
    }, initialValue);
    if (stateActivities.length === 0) {
      return [];
    }
    if (stateActivities.length === 1) {
      return [Object.assign({}, activityDefinitions.find(function (v) {
        return v.id === stateActivities[0];
      }) || {
        name: state.name
      }, {
        state: state,
        key: stateActivities[0] + " " + state.key,
        color: state.getHSLColor({})
      })];
    }
    var lightnessDelta = MAX_LIGHTNESS / stateActivities.length;
    return stateActivities.map(function (stateActivity, i) {
      var definition = activityDefinitions.find(function (v) {
        return v.id === stateActivity;
      }) || {};
      var activityName = definition.name || "";
      if (!activityName.replace(/\s/g, "")) {
        definition.name = state.name;
      }
      return Object.assign({}, definition, {
        state: state,
        key: stateActivity + " " + state.key,
        color: state.getHSLColor({
          lightness: lightnessDelta * (i + 1)
        })
      });
    });
  });
  return coloredActivities;
}
var _default = exports["default"] = getActivitiesColoring;